import { Room } from '../room';

export class Location {
    constructor(
        public id: number,
        public name: string,
        public address1: string,
        public address2: string,
        public city: string,
        public countryCode: string,
        public rooms: Room[],
        public version: number,
        public deleted: boolean
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/location/location.model.ts